import React from 'react';
import './Brokerage.css';

// Eingebettete (nicht als Overlay) Variante des PIN/TAN-Logins aus dem
// fruehreren BrokerageModal - wird von allen Brokerage-Seiten (Depotuebersicht,
// Orderbuch, Order aus einer Vorlage) gleich benutzt, weil jede von ihnen vor
// dem ersten comdirect-Zugriff denselben Login-Vorgang braucht. PIN/TAN leben
// nur lokal in diesem Formular, der fertige Token bleibt serverseitig in
// $_SESSION (siehe BrokerageTask.inc) - dieses Formular erfaehrt nur "fertig".
export default function BrokerageLoginForm(props) {

	const x = props.x;
	const task = (name, data, cb) => x.was.axPost('Backend/webapp.php?module=Banking&task=' + name, data, cb);

	const [pin, setPin] = React.useState('');
	const [remember, setRemember] = React.useState(false);
	const [tanCode, setTanCode] = React.useState('');
	const [challenge, setChallenge] = React.useState(null);
	const [busy, setBusy] = React.useState(false);
	const [error, setError] = React.useState('');

	function submitPin() {
		if (pin === '') return;
		setBusy(true);
		setError('');
		task('BrokerageLogin', { connectionId: props.connectionId, pin, rememberPin: remember ? 1 : 0 }, (result) => {
			setBusy(false);
			const content = result.data.content || {};
			if (result.data.returncode !== 1) {
				setError(content.message || 'Login fehlgeschlagen.');
				return;
			}
			setChallenge({ type: content.challengeType, text: content.challengeText });
			setTanCode('');
		});
	}

	function submitTan() {
		setBusy(true);
		setError('');
		task('BrokerageTanConfirm', { connectionId: props.connectionId, tanCode }, (result) => {
			setBusy(false);
			if (result.data.returncode !== 1) {
				setError(result.data.content.message || 'TAN-Bestätigung fehlgeschlagen.');
				return;
			}
			setPin('');
			setTanCode('');
			props.onLoggedIn();
		});
	}

	const needsCode = challenge && challenge.type === 'M_TAN';

	return (
		<div className="brokerage-card">
			{challenge === null
				?
					<React.Fragment>
						<label htmlFor="brokerage-login-pin">PIN für {props.accountLabel}</label>
						<input
							id="brokerage-login-pin"
							className="brokerage-pin-input"
							type="text"
							inputMode="numeric"
							autoComplete="one-time-code"
							value={pin}
							onChange={(e) => setPin(e.target.value)}
							onKeyDown={(e) => { if (e.key === 'Enter') submitPin(); }}
							autoFocus
						/>
						{props.pinUse &&
							<label className="brokerage-remember">
								<input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
								PIN merken (verschlüsselt, nur dieser Browser)
							</label>
						}
						{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
						<button type="button" className="btn" disabled={busy || pin === ''} onClick={submitPin}>
							{busy ? 'Verbinde…' : 'Anmelden'}
						</button>
					</React.Fragment>
				:
					<React.Fragment>
						{challenge.type === 'P_TAN_PUSH' &&
							<p className="brokerage-hint"><i className="bi bi-phone"></i> Bitte in der comdirect-App bestätigen.</p>
						}
						{challenge.text && <p className="brokerage-hint">{challenge.text}</p>}
						{needsCode &&
							<React.Fragment>
								<label htmlFor="brokerage-login-tan">TAN</label>
								<input
									id="brokerage-login-tan"
									type="text"
									autoComplete="off"
									value={tanCode}
									onChange={(e) => setTanCode(e.target.value)}
									onKeyDown={(e) => { if (e.key === 'Enter') submitTan(); }}
									autoFocus
								/>
							</React.Fragment>
						}
						{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
						<button type="button" className="btn" disabled={busy || (needsCode && tanCode === '')} onClick={submitTan}>
							{busy ? 'Bestätige…' : 'Bestätigen'}
						</button>
					</React.Fragment>
			}
		</div>
	)

};
